"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./utils/FontName"), exports);
tslib_1.__exportStar(require("./utils/FontSize"), exports);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-format-options/lib/index.js
// module id = 2132
// module chunks = 2 3 59 108